// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification","notification-image":"notification-image","notification-title":"notification-title","notification-content":"notification-content","has-image":"has-image"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/notifications/component/notification/notification.style.sass
// module id = vymh
// module chunks = 0